import React from 'react'
import { ContainerRow, VerticalLine } from './styles'
import { AlertMessage, RowContentPart, RowInfoPart, TimelineConducts, TimelineOmics } from '~/components/shared'
import { IAdmissionRowSlots, IHealthProcedures } from '~/interfaces'
import { message } from '~/services'
import { byTypeEqualToAdmission, byTypeExceptAdmission, filterHealthProceduresPer, timelineFilters } from '~/utils'
import { mapperTimelineViewByDaysFrom } from '~/utils/dashboard/timeline/maternalInfant'
import { useMaternalInfantHealthProcedures } from '~/context'
import { createAdmissionsSlotsFrom } from '~/utils/dashboard/timeline/mappers'

interface TimelineViewByDaysProps {
  timelineRange: [Date, Date]
  healthProcedures: IHealthProcedures[]
  onSelectEvent: (healthProcedures: IHealthProcedures[]) => void
}

export const TimelineViewByDays = ({
  timelineRange,
  healthProcedures,
  onSelectEvent
}: TimelineViewByDaysProps): JSX.Element => {
  const { typeFiltersActive, dateFiltersActive, filterTags } = useMaternalInfantHealthProcedures()

  const applyTimelineFilters = (healthProcedures: IHealthProcedures[]): IHealthProcedures[] => {
    const searchTerms = filterTags?.filter(tag => tag.type === 'searchTerm').map(tag => tag.text)
    return timelineFilters(healthProcedures)
      .perDate(dateFiltersActive)
      .perType(typeFiltersActive)
      .perMultipleTextTerms(searchTerms).value
  }

  const filteredEvents = applyTimelineFilters(healthProcedures)

  if (!filteredEvents || filteredEvents.length <= 0) {
    return <AlertMessage>{message('maternalInfant.empty_timeline_section')}</AlertMessage>
  }

  const structuredData = mapperTimelineViewByDaysFrom(filteredEvents, ...timelineRange)

  const handleHealthProcedures = (selectedHealthProcedures: IHealthProcedures[]) => {
    onSelectEvent(selectedHealthProcedures)
  }

  const handleAdmissions = (selectedAdmissions: IAdmissionRowSlots[]) => {
    const rawAdmission = healthProcedures.find(healthProcedure => healthProcedure.id === selectedAdmissions[0].id)
    const healthProceduresWithoutAdmissions = filterHealthProceduresPer(healthProcedures, byTypeExceptAdmission)
    const healthProceduresInRange = timelineFilters(healthProceduresWithoutAdmissions).perEventStartDate(
      timelineRange
    ).value

    if (rawAdmission) {
      const admissionSlots = createAdmissionsSlotsFrom([rawAdmission], healthProceduresInRange)
      onSelectEvent(admissionSlots[0].healthProcedures)
    }
  }

  return (
    <>
      {structuredData.days.map((day, dayIndex, daysArray) => {
        const rowSlots = day.rowSlots
        const healthProceduresWithoutAdmissions = filterHealthProceduresPer(rowSlots, byTypeExceptAdmission)
        const admissions = filterHealthProceduresPer(rowSlots, byTypeEqualToAdmission)

        return (
          <ContainerRow key={`day-${day.id}`}>
            <RowInfoPart isFilled={false} period={`Dia ${day.id}`}>
              <VerticalLine isFirst={dayIndex === 0} isLast={dayIndex === daysArray.length - 1} />
            </RowInfoPart>
            <RowContentPart isFull={false} isFilled={false}>
              {/* CONTENT ROW */}
              {healthProceduresWithoutAdmissions.length > 0 && (
                <TimelineOmics
                  period="days"
                  healthProcedures={healthProceduresWithoutAdmissions}
                  handleClick={handleHealthProcedures}
                />
              )}

              {admissions.length > 0 && (
                <TimelineConducts healthProcedures={admissions} period="days" handleClick={handleAdmissions} />
              )}
            </RowContentPart>
          </ContainerRow>
        )
      })}
    </>
  )
}
